import { format, parseISO } from 'date-fns';
import { de, enUS, fr } from 'date-fns/locale';

import { Locale as ELocale } from '@/helpers/languages';

const LOCALE_MAP: Record<string, Locale> = {
  [ELocale.GERMAN]: de,
  [ELocale.FRENCH_CANADA]: fr,
  [ELocale.FRENCH_SWITZERLAND]: fr,
};

const DATE_FORMAT = 'dd.MM.yyyy';

export const getLocale = (language: string) => LOCALE_MAP[language] || enUS;

export const formatPromoDate = (
  date: string,
  locale: Locale,
  dateFormat = DATE_FORMAT
) => format(parseISO(date), dateFormat, { locale });
